import { c as _c } from "react/compiler-runtime";
import { IcoWarning40 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
const DeviceNotSupportedError = () => {
  const $ = _c(13);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.components.device-not-supported-error"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoWarning40 color="error" />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t(_temp);
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <span className="text-label-1 text-primary text-center">{t2}</span>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-body-2 text-secondary text-center">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex flex-col items-center gap-2 p-4 pt-14 pb-8">{t1}{t3}{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default DeviceNotSupportedError;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}